import { IEventDefinition } from "@highway/mbs-analytics";

const appEvents: Record<string, IEventDefinition> = {
    rerc_generate_report: {
        description: 'Fires when a user clicks "Next" to generate the report.',
        mappings: {
            mixpanel: "rerc_generate_report",
        },
    },
};

export default appEvents;
